module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/promo/2/3-79497018ccd4d68ab2bfaacfc0f80fce.png";